import _ from "lodash";
import i18next from "i18next";
import ACLStore from "lib/aclStore";

export const isNewPYPConceptsLabelEnabled = () => {
  return ACLStore.can("FeatureFlag:NewPYPConceptsLabelEnabled");
};

const variableConfigUpdated = {
  RC: "common:related_concepts_updated",
  RCL: "common:related_concepts_lowercase_updated",
  RCS: "common:related_concept_updated",
  RCSL: "common:related_concept_lowercase_updated",
  KC: "common:key_concepts_updated",
  KCL: "common:key_concepts_lowercase_updated",
  KCS: "common:key_concept_updated",
  KCSL: "common:key_concept_lowercase_updated",
};
const variableConfig = {
  RC: "common:related_concepts",
  RCL: "common:related_concepts_lowercase",
  RCS: "common:related_concept",
  RCSL: "common:related_concept_lowercase",
  KC: "common:CONCEPT",
  KCL: "common:key_concepts_lowercase",
  KCS: "common:key_concept",
  KCSL: "common:key_concept_lowercase",
};

const variables = {};

const updateVariables = () => {
  const variableConfiguration = isNewPYPConceptsLabelEnabled();
  _.forEach(
    variableConfiguration ? variableConfigUpdated : variableConfig,
    (translationKey, variableName) => {
      _.set(variables, variableName, i18next.t(translationKey));
    }
  );
};

updateVariables();

i18next.on("languageChanged", updateVariables);

export default variables;
